module.exports = __webpack_public_path__ + "img/about01.ba115034.png";